export default __webpack_public_path__ + "static/media/gw2.82a50a0a.webp";